<template>
    <!-- 头部 -->
    <div>
        <div class="headercp">
            <div class="cont w1366">
                <div class="logo"><img src="../assets/logo.png"></div>
                <div class="nav">
                    <div class="li" v-for="(item,index) in navboxmax" :key="index" :class="[messages==index?'on':'']" @click="nacclick(item.path)">  <!-- navnum -->
                        <div class="tit">{{item.name}}</div>
                    </div>
                </div>
                <div class="more">
                    <!-- <div class="i i1"></div> -->
                    <div class="i i2" @click="indexlogin"></div>
                </div>
            </div>
        </div>
        <!--  -->
        <div class="headercplist">  <!-- v-if="headercplist" -->
            <div class="sole"></div>
            <div class="wker">
                <div class="cont w1366">
                    <div class="list">
                        <div class="wli">
                            <div class="tit">WEB开发</div>
                            <div class="min">
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w25.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">高端网站建设</div>
                                        <div class="p">企业/政府 响应式网站</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w26.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">H5</div>
                                        <div class="p">活动/动画/游戏 手机端H5</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w27.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">应用系统</div>
                                        <div class="p">B/S架构WEB应用系统/软件</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w28.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">可视化数据看版</div>
                                        <div class="p">指挥中心/数据大屏系统</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wli">
                            <div class="tit">微信开发</div>
                            <div class="min">
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w29.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">公众号</div>
                                        <div class="p">微信公众号应用开发</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w30.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">小程序</div>
                                        <div class="p">微信小程序应用功能开发</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w31.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">企业微信</div>
                                        <div class="p">基于企业微信的应用开发</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w32.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">其它应用</div>
                                        <div class="p">抖音/支付宝/百度等开发</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wli">
                            <div class="tit">APP开发</div>
                            <div class="min">
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w33.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">Android</div>
                                        <div class="p">基于UNI-APP的应用开发</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w34.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">IOS</div>
                                        <div class="p">基于UNI-APP的应用开发</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wli">
                            <div class="tit">云产品</div>
                            <div class="min">
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w35.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">域名</div>
                                        <div class="p">阿里云｜协助注册并备案</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w36.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">服务器</div>
                                        <div class="p">阿里云ECS</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w37.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">SSL安全证书</div>
                                        <div class="p">阿里云数字证书管理服务</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w38.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">安全运维</div>
                                        <div class="p">服务器托管/安全维护</div>
                                    </div>
                                </div>
                                <div class="li">
                                    <div class="m"><img src="../assets/images/w39.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">AI工具</div>
                                        <div class="p">AI智能工具集成</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wli">
                            <div class="tit">其它产品</div>
                            <div class="min">
                                <div class="li" @click="nacclick('/mould')">
                                    <div class="m"><img src="../assets/images/w40.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">模版小程序</div>
                                        <div class="p">低成本上线快模版小程序</div>
                                    </div>
                                </div>
                                <div class="li" @click="casesclick()">
                                    <div class="m"><img src="../assets/images/w41.png" alt=""></div>
                                    <div class="ter">
                                        <div class="h">律所案件管理系统</div>
                                        <div class="p">自研Saas产品</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="more" @click="moresri"><i>查看详情</i></div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                navboxmax: [
                    { name: '首页', path: '/index' },
                    { name: '服务', path: '' },
                    { name: '案例', path: '/case' },
                    { name: '观点', path: '/news' },
                    { name: '关于', path: '/about' }
                ],
                //navnum: 0,
                headercplist: false
            }
        },
        methods: {
            // this.$router.push('/home')
            nacclick(path,index){
                // this.navnum = index
                // this.$router.push(path);
                // this.$router.go(0);
                this.$router.push(path).catch(err=>{ })
                // this.headercplist = true
                window.scrollTo(0,0);
            },
			casesclick(){
			    const url = 'http://cases.gsyzkj.cn';
			    // window.location.href = url;
			    window.open(url)
			},
            indexlogin(){
                const url = 'http://xcx.gsyzkj.cn';
                // window.location.href = url;
                window.open(url)
            },
            moresri(){
                this.$router.push('/serve').catch(err=>{ })
                window.scrollTo(0,0);
            }
        },
        props: ['messages']
    }
</script>

<style>
    .headercplist{ display: none;}
</style>